import { ReactComponent as HomeFilled } from 'asset/IconsPack/at_grid-01-filled.svg';
import { ReactComponent as Home } from 'asset/IconsPack/at_grid-01.svg';
import { ReactComponent as MedallionFilled } from 'asset/IconsPack/at_shield-tick-filled.svg';
import { ReactComponent as Medallion } from 'asset/IconsPack/at_shield-tick.svg';
import { ReactComponent as SettingsFilled } from 'asset/IconsPack/at_tool-02-filled.svg';
import { ReactComponent as Settings } from 'asset/IconsPack/at_tool-02.svg';
import { ReactComponent as UserFilled } from 'asset/IconsPack/at_user-01-filled.svg';
import { ReactComponent as User } from 'asset/IconsPack/at_user-01.svg';
import { ReactComponent as Integrations } from 'asset/icons/integration.svg';
import { ReactComponent as IntegrationsFilled } from 'asset/icons/integration_filled.svg';
import { ReactComponent as Tcm } from 'asset/icons/tcm_icon.svg';
import { ReactComponent as TcmFilled } from 'asset/icons/tcm_icon_filled.svg';

const NAV_ITEM_IDS = {
    HOME: 'home',
    USERS: 'users',
    MEDALLION_WORKFLOWS: 'medallion_workflows',
    TRUE_CONTINUOUS_MONITORING: 'true_continuous_monitoring',
    INTEGRATIONS: 'integrations',
    SETTINGS: 'settings',
};

export const navigationItems = [
    {
        id: NAV_ITEM_IDS.HOME,
        label: 'Home',
        path: '/dashboard',
        icons: {
            default: <Home />,
            selected: <HomeFilled />,
        },
    },
    {
        id: NAV_ITEM_IDS.USERS,
        label: 'Users',
        path: '/users',
        icons: {
            default: <User />,
            selected: <UserFilled />,
        },
    },
    {
        id: NAV_ITEM_IDS.MEDALLION_WORKFLOWS,
        label: 'Medallion™ Workflows',
        path: '/workflows',
        icons: {
            default: <Medallion />,
            selected: <MedallionFilled />,
        },
    },
    {
        id: NAV_ITEM_IDS.TRUE_CONTINUOUS_MONITORING,
        label: 'True Continuous Monitoring™',
        path: '/tcm',
        icons: {
            default: <Tcm />,
            selected: <TcmFilled />,
        },
    },
    {
        id: NAV_ITEM_IDS.INTEGRATIONS,
        label: 'Integrations',
        path: '/integrations',
        icons: {
            default: <Integrations />,
            selected: <IntegrationsFilled />,
        },
    },
    {
        id: NAV_ITEM_IDS.SETTINGS,
        label: 'Settings',
        path: '/settings',
        icons: {
            default: <Settings />,
            selected: <SettingsFilled />,
        },
    },
];

export const NAVBAR_TOOLTIP_MESSAGES = {
    [NAV_ITEM_IDS.MEDALLION_WORKFLOWS]: 'Medallion™ Workflows',
    [NAV_ITEM_IDS.TRUE_CONTINUOUS_MONITORING]: 'True Continuous Monitoring™',
};
